var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "add-item-to-basket-overlay" } }, [
    _c("div", { staticClass: "modal fade" }, [
      _c(
        "div",
        { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
        [
          _vm.basketItem
            ? _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "d-flex" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-title h5" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Ceres::Template.singleItemAdded")
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(1)
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row is-table-row" }, [
                    _c(
                      "div",
                      { staticClass: "container" },
                      [
                        _c("h3", { staticClass: "text-center mt-2 mb-4" }, [
                          _vm._v("Benötigst du noch etwas dazu?")
                        ]),
                        _vm._v(" "),
                        _vm._t("duft-pflege")
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer row" }, [
                  _c("span", {
                    staticClass: "col-6 col-sm-4 vat-after-total",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate("TuningFanatics::Template.vat")
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 col-sm-4 mb-2 mb-sm-0" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "waiting-animation-infinite",
                            rawName: "v-waiting-animation-infinite"
                          }
                        ],
                        staticClass:
                          "w-100 btn btn-outline-primary btn-medium mr-2",
                        attrs: { href: _vm.urls.basket, rel: "nofollow" }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-shopping-cart",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$translate("Ceres::Template.singleItemBasket")
                            ) +
                            "\n                            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-sm-4" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "waiting-animation-infinite",
                            rawName: "v-waiting-animation-infinite"
                          }
                        ],
                        staticClass: "w-100 btn btn-primary btn-medium",
                        attrs: { href: _vm.urls.checkout, rel: "nofollow" }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-arrow-right",
                          attrs: { "aria-hidden": "true" }
                        }),
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.singleItemCheckout"
                              )
                            ) +
                            "\n                            "
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-between mt-4 mb-2" },
                  [
                    _c("h3", [
                      _vm._v("Noch schneller und bequemer zahlen mit:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ppexpress-wrapper" },
                      [_vm._t("extendOverlayButtons")],
                      2
                    )
                  ]
                )
              ])
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text-muted" }, [
      _c("span", { staticClass: "timer" }),
      _vm._v("s - ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close ml-0 pl-1",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }